import { render, staticRenderFns } from "./GenerateAgeAverage.vue?vue&type=template&id=328ab496&scoped=true&"
import script from "./GenerateAgeAverage.vue?vue&type=script&lang=js&"
export * from "./GenerateAgeAverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ab496",
  null
  
)

export default component.exports